'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import { IParent } from '@/creditflowresearch/domain/vo/IDeal';
import {
  ICorporateTopFilterPayload, ITopPeriodCorporate,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/interfaces';
import {
  useTopCompanyCommonCorporate,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesCommonCorporate/useTopCompanyCommonCorporate';

export interface ITopParentsCorporate {
  periods: {
    collection: ITopPeriodCorporate[],
    hasServerError: boolean,
  },
  totalCount: number,
  includedRole: string,
  parent: IParent,
  filters: ICorporateTopFilterPayload,
}

type TopCompanyCommonContextType = ReturnType<typeof useTopCompanyCommonCorporate>;

export const TopCompanyCommonCorporateContext = createContext<TopCompanyCommonContextType>(null);

export const useTopCompanyCommonCorporateContext = () => {
  const context = useContext(TopCompanyCommonCorporateContext);
  if (!context) {
    throw new Error('useTopCompanyCommonCorporateContext must be used within the TopCompanyCommonCorporateContext');
  }
  return context;
};

interface IProps {
  topParents: ITopParentsCorporate,
}

const TopCompanyCommonCorporateContextProvider = ({ children, topParents }: PropsWithChildren<IProps>) => (
  <TopCompanyCommonCorporateContext.Provider value={ useTopCompanyCommonCorporate(topParents) }>
    { children }
  </TopCompanyCommonCorporateContext.Provider>
);

export default TopCompanyCommonCorporateContextProvider;
